import { useFormContext } from 'react-hook-form'
import { Input } from '../ui/Input'
import { OptionCard } from '../ui/OptionCard'
import type { FormData } from './FormWizard'

const urgencyOptions = [
  {
    value: 'asap',
    label: 'ASAP - Emergency',
    description: 'I need help right away',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    value: 'this-week',
    label: 'This Week',
    description: 'Within the next few days',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    value: 'this-month',
    label: 'This Month',
    description: 'No immediate rush',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
      </svg>
    ),
  },
  {
    value: 'flexible',
    label: 'Flexible',
    description: "Just exploring options",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    ),
  },
]

export function StepLocation() {
  const { register, watch, formState: { errors } } = useFormContext<FormData>()
  const selectedUrgency = watch('urgency')

  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Location & Timeline
        </h2>
        <p className="text-gray-600">
          We serve Southern California - Santa Barbara to San Diego
        </p>
      </div>

      <div className="space-y-6">
        {/* Zip Code */}
        <Input
          {...register('zip_code', {
            pattern: {
              value: /^\d{5}(-\d{4})?$/,
              message: 'Please enter a valid ZIP code',
            },
          })}
          label="ZIP Code"
          placeholder="90210"
          error={errors.zip_code?.message}
          hint="We serve all of Southern California"
        />

        {/* Urgency */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">
            How soon do you need help?
          </label>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {urgencyOptions.map((option) => (
              <OptionCard
                key={option.value}
                {...register('urgency')}
                value={option.value}
                label={option.label}
                description={option.description}
                icon={option.icon}
                selected={selectedUrgency === option.value}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
